import { THOUSANDS_REGEX } from '../../constants';

const NON_DIGIT_REGEX = /[^0-9]/g;

class DigitFormatter {
  static tryParse(format) {
    return format === 'digit' ? new DigitFormatter() : null;
  }

  /**
   * Shared by apply() and parse(): the digits before the first decimal point, without a sign, nothing else.
   * Numbers are read without exponent notation (1e21); strings are read by their digits only, never through
   * Number(), so a string like '1e3' reads as '13' (accepted, as in IntegerFormatter).
   */
  static clean(value) {
    const text =
      typeof value === 'number' ? value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 20 }) : value.toString();

    return text.split('.')[0].replace(NON_DIGIT_REGEX, '');
  }

  apply(value) {
    if (!value) return 0;

    const digits = DigitFormatter.clean(value).replace(/^0+(?=\d)/, '');
    if (!digits) return 0;

    // Insert a comma every 3 digits (display only; parse() saves the bare digits).
    return digits.replace(THOUSANDS_REGEX, ',');
  }

  parse(value) {
    if (!value) return value;
    return DigitFormatter.clean(value);
  }
}
export default DigitFormatter;
